import { environment } from '../../../../environments/environment';

export class TagService {
  static $inject = ['RestResource'];

  constructor(private RestResource) {}

  apiUrl = environment.apiEndpoint + 'tags';

  getFilterCriteria() {
    var filterCriteria = {};

    return filterCriteria;
  }

  getTags(filterCriteria) {
    if (!filterCriteria) {
      // Default criteria
      filterCriteria = this.getFilterCriteria();
    }

    return this.RestResource.request(
      'get',
      this.apiUrl,
      filterCriteria,
      function (response) {
        // service.items = response.data;
        return response.data;
      },
      {}
    );
  }

  tagTransform(name, lang) {
    var item = {
      name: name,
      lang: lang,
    };

    return item;
  }

  checkTagOptions(tag, tags) {
    var tagOptions = [];
    if (tag.length >= 1) {
      tagOptions = tags;
    }

    return tagOptions;
  }
}
